import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

interface ComponentProps {
  totalPage: number;
  rootUrl: string;
  currentPage: number;
}

const Pagination = ({ rootUrl, totalPage, currentPage }: ComponentProps) => {
  return (
    <>
      <Wrapper>
        <Inner>
          {Array.from(Array(totalPage)).map((item, idx: number) => (
            <PaginationButton
              active={idx === currentPage - 1}
              key={item}
              to={`${rootUrl}/${idx + 1}`}
            >
              {idx + 1}
            </PaginationButton>
          ))}
        </Inner>
      </Wrapper>
    </>
  );
};

export default Pagination;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const Inner = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const PaginationButton = styled(Link)<any>`
  text-decoration: none;
  padding: 10px;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 600;
  font-family: font-semibold;
  margin: 2px;
  background-color: rgba(93, 165, 237, 0.2);
  color: rgb(93, 165, 237);
  transition: 0.3s;

  &:hover {
    background-color: rgb(93, 165, 237);
    color: rgb(255, 255, 255);
  }

  ${(props: any) =>
    props?.active &&
    css`
      background-color: rgb(93, 165, 237);
      color: rgb(255, 255, 255);

      &:hover {
        background-color: rgb(41, 118, 196);
        color: rgb(255, 255, 255);
      }
    `}
`;
